module.exports = __webpack_public_path__ + "static/44gde-e9c8a0b27c068f253d0bb42f761dd8e0.gif";